import React, { createContext, createElement, useContext, useState, Fragment } from 'react';
import { FAILURE_MODAL_VIEW, SUCCESS_MODAL_VIEW, MESSAGE_BUTTON_VIEW } from '@ctxhou/ciaociao-types/dist/formConfig';
import { FORM_LABEL, SENT_EVENT, FAILED_TO_SUBMIT_EVENT, MESSAGE_BUTTON_LABEL, CLICK_EVENT, HIDE_EVENT, SUBMIT_EVENT } from '@ctxhou/ciaociao-types/dist/dispatchActions';
import clsx2 from 'clsx';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { genYupValidatorBySchema } from '@ctxhou/ciaociao-validation';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import { ZhHantLocale } from '@ctxhou/ciaociao-types';

var ThemeContext = createContext({});

function useTheme() {
  var context = useContext(ThemeContext);

  if (!context) {
    throw new Error("useTheme must be used within a ViewProvider");
  }

  return context;
}

function ThemeProvider(ref) {
  var theme = ref.theme;
  var children = ref.children;

  return /* @__PURE__ */createElement(ThemeContext.Provider, {
    value: theme
  }, children);
}

function SvgComponent() {
  return /* @__PURE__ */createElement("svg", {
    height: 20,
    viewBox: "0 0 24 24",
    width: 20
  }, /* @__PURE__ */createElement("path", {
    d: "M8.75 17.612v4.638a.751.751 0 001.354.444l2.713-3.692zM23.685.139a.75.75 0 00-.782-.054l-22.5 11.75a.752.752 0 00.104 1.375l6.255 2.138 13.321-11.39L9.775 16.377l10.483 3.583a.753.753 0 00.984-.599l2.75-18.5a.751.751 0 00-.307-.722z"
  }));
}

function SvgComponent$1() {
  return /* @__PURE__ */createElement("svg", {
    version: "1.1",
    id: "Capa_1",
    height: 20,
    width: 20,
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 384"
  }, /* @__PURE__ */createElement("g", null, /* @__PURE__ */createElement("g", null, /* @__PURE__ */createElement("path", {
    d: "M353.188,252.052c-23.51,0-46.594-3.677-68.469-10.906c-10.719-3.656-23.896-0.302-30.438,6.417l-43.177,32.594\n			c-50.073-26.729-80.917-57.563-107.281-107.26l31.635-42.052c8.219-8.208,11.167-20.198,7.635-31.448\n			c-7.26-21.99-10.948-45.063-10.948-68.583C132.146,13.823,118.323,0,101.333,0H30.813C13.823,0,0,13.823,0,30.813\n			C0,225.563,158.438,384,353.188,384c16.99,0,30.813-13.823,30.813-30.813v-70.323C384,265.875,370.177,252.052,353.188,252.052z"
  }))), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null));
}

function SvgComponent$2() {
  return /* @__PURE__ */createElement("svg", {
    height: 20,
    width: 20,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */createElement("path", {
    d: "m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 405.332031c-11.777344 0-21.332031-9.554687-21.332031-21.332031s9.554687-21.332031 21.332031-21.332031 21.332031 9.554687 21.332031 21.332031-9.554687 21.332031-21.332031 21.332031zm33.769531-135.636719c-7.550781 3.476563-12.4375 11.09375-12.4375 19.394532v9.578125c0 11.773437-9.535156 21.332031-21.332031 21.332031s-21.332031-9.558594-21.332031-21.332031v-9.578125c0-24.898438 14.632812-47.722656 37.226562-58.15625 21.738281-10.003906 37.4375-36.566406 37.4375-49.601563 0-29.394531-23.914062-53.332031-53.332031-53.332031s-53.332031 23.9375-53.332031 53.332031c0 11.777344-9.539063 21.335938-21.335938 21.335938s-21.332031-9.558594-21.332031-21.335938c0-52.925781 43.070312-96 96-96s96 43.074219 96 96c0 28.824219-25.003906 71.191407-62.230469 88.363281zm0 0"
  }));
}

function SvgComponent$3() {
  return /* @__PURE__ */createElement("svg", {
    height: 20,
    width: 20,
    viewBox: "0 0 511.996 511.996",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */createElement("path", {
    d: "m230.9 253.371c13.369 8.913 36.827 8.914 50.199-.001.002-.001.005-.003.007-.004l227.865-151.911c-7.474-21.616-28.018-37.188-52.142-37.188h-401.663c-24.125 0-44.668 15.572-52.143 37.188l227.87 151.912c.003.002.005.002.007.004z"
  }), /* @__PURE__ */createElement("path", {
    d: "m297.746 278.328c-.003.002-.005.004-.007.005-11.702 7.801-26.724 11.702-41.741 11.702-15.02 0-30.036-3.9-41.739-11.703-.002-.001-.003-.002-.005-.003l-214.254-142.835v257.072c0 30.417 24.747 55.163 55.166 55.163h401.666c30.418 0 55.164-24.746 55.164-55.163v-257.072z"
  }));
}

function SvgComponent$4() {
  return /* @__PURE__ */createElement("svg", {
    height: 20,
    width: 20,
    viewBox: "0 0 511.606 511.606",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */createElement("path", {
    d: "m436.594 74.943c-99.917-99.917-261.637-99.932-361.568 0-80.348 80.347-95.531 199.817-48.029 294.96l-26.335 115.839c-3.423 15.056 10.071 28.556 25.133 25.133l115.839-26.335c168.429 84.092 369.846-37.653 369.846-228.812 0-68.29-26.595-132.494-74.886-180.785zm-127.451 244.451h-160c-11.598 0-21-9.402-21-21s9.402-21 21-21h160c11.598 0 21 9.402 21 21s-9.402 21-21 21zm53.334-85.333h-213.334c-11.598 0-21-9.402-21-21s9.402-21 21-21h213.334c11.598 0 21 9.402 21 21s-9.403 21-21 21z"
  }));
}

var iconMapping = {
  email: SvgComponent,
  call: SvgComponent$1,
  question: SvgComponent$2,
  envelop: SvgComponent$3,
  chat: SvgComponent$4
};

var styles = {"reset":"Button-module_reset__1nTDB","buttonStyle":"Button-module_buttonStyle__1QZmR"};

function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }

var Button = function (ref) {
  var children = ref.children;
  var className = ref.className;
  var type = ref.type; if ( type === void 0 ) type = "button";
  var onClick = ref.onClick;
  var style = ref.style;
  var rest = objectWithoutProperties( ref, ["children", "className", "type", "onClick", "style"] );
  var props = rest;

  return createElement("button", Object.assign({}, {className: clsx2(styles.reset, styles.buttonStyle, className),
  type: type,
  onClick: onClick,
  "aria-label": "button",
  style: style},
  props), children);
};

var UiConfigContext = createContext({});

function useUiConfig() {
  var context = useContext(UiConfigContext);

  if (!context) {
    throw new Error("useUiConfig must be used within a ProjectProvider");
  }

  return context;
}

function UiConfigProvider(ref) {
  var uiConfig = ref.uiConfig;
  var locale = ref.locale;
  var children = ref.children;

  return /* @__PURE__ */createElement(UiConfigContext.Provider, {
    value: {
      uiConfig: uiConfig,
      locale: locale
    }
  }, children);
}

var styles$1 = {"wrapper":"MessageButton-module_wrapper__pz8MO","inline":"MessageButton-module_inline__1IvdU","modal":"MessageButton-module_modal__1dmtN","buttonStyle":"MessageButton-module_buttonStyle__2TdO_","buttonIsMobile":"MessageButton-module_buttonIsMobile__1AyeR","buttonIcon":"MessageButton-module_buttonIcon__1HS36","buttonText":"MessageButton-module_buttonText__a8BEx"};

var MessageButton = function (ref) {
  var handleClick = ref.handleClick;
  var isPreview = ref.isPreview;
  var isInline = ref.isInline;
  var isMobile = ref.isMobile;

  var theme = useTheme();
  var ref$1 = useUiConfig();
  var uiConfig = ref$1.uiConfig;
  var Icon = uiConfig.icon ? iconMapping[uiConfig.icon] : iconMapping.email;
  var onClickFn = isPreview ? function () {} : handleClick;
  return /* @__PURE__ */createElement("div", {
    className: clsx2(styles$1.wrapper, isInline ? styles$1.inline : styles$1.modal)
  }, /* @__PURE__ */createElement(Button, {
    style: {
      backgroundColor: theme.themeColor
    },
    className: clsx2(styles$1.buttonStyle, isMobile ? styles$1.buttonIsMobile : null),
    onClick: onClickFn
  }, /* @__PURE__ */createElement("span", {
    className: styles$1.buttonIcon
  }, /* @__PURE__ */createElement(Icon, null)), uiConfig.ctaTitle && !isMobile ? /* @__PURE__ */createElement("span", {
    className: styles$1.buttonText
  }, uiConfig.ctaTitle) : null));
};

function SvgComponent$5() {
  return /* @__PURE__ */createElement("svg", {
    viewBox: "0 0 492 492",
    width: 10,
    height: 10,
    style: {
      fill: "white"
    }
  }, /* @__PURE__ */createElement("path", {
    d: "M465.064 207.562H26.908C12.076 207.562 0 219.698 0 234.53v22.804c0 14.832 12.072 27.104 26.908 27.104h438.156c14.84 0 26.936-12.272 26.936-27.104V234.53c0-14.832-12.096-26.968-26.936-26.968z"
  }));
}

var styles$2 = {"wrapper":"ModalHeader-module_wrapper__3ha4D","innerWrapper":"ModalHeader-module_innerWrapper__35ZOp","title":"ModalHeader-module_title__2sTvB"};

var shareStyles = {"fieldStyle":"shareStyle-module_fieldStyle__3UciL","textAreaStyle":"shareStyle-module_textAreaStyle__8vcrL","fieldErrorStyle":"shareStyle-module_fieldErrorStyle__BTVOk"};

var ModalHeader = function (ref) {
  var handleHideForm = ref.handleHideForm;

  var theme = useTheme();
  var ref$1 = useUiConfig();
  var uiConfig = ref$1.uiConfig;
  return /* @__PURE__ */createElement("div", {
    style: {
      backgroundColor: theme.themeColor
    },
    className: clsx2(shareStyles.root, styles$2.wrapper)
  }, /* @__PURE__ */createElement("div", {
    className: styles$2.innerWrapper
  }, /* @__PURE__ */createElement("p", {
    className: clsx2(shareStyles.root, styles$2.title)
  }, uiConfig.ctaTitle), /* @__PURE__ */createElement(Button, {
    style: {
      backgroundColor: theme.themeColor,
      borderColor: theme.themeColor
    },
    onClick: handleHideForm
  }, /* @__PURE__ */createElement(SvgComponent$5, null))));
};

var styles$3 = {"iconLine":"CheckIcon-module_iconLine__GYwVJ","wrapper":"CheckIcon-module_wrapper__25gcH","innerWrapper":"CheckIcon-module_innerWrapper__SrQqU","rotateCircle":"CheckIcon-module_rotateCircle__2SKjH","lineTip":"CheckIcon-module_lineTip__1csD1","lineLong":"CheckIcon-module_lineLong__2LhS1","lineStyle2":"CheckIcon-module_lineStyle2__1hfe0","lineStyle3":"CheckIcon-module_lineStyle3__CG-L1"};

var CheckIcon = function () { return createElement("div", {
  className: styles$3.wrapper
}, /* @__PURE__ */createElement("div", {
  className: styles$3.innerWrapper
}, /* @__PURE__ */createElement("span", {
  className: clsx2(styles$3.iconLine, styles$3.lineTip)
}), /* @__PURE__ */createElement("span", {
  className: clsx2(styles$3.iconLine, styles$3.lineLong)
}), /* @__PURE__ */createElement("div", {
  className: styles$3.lineStyle2
}), /* @__PURE__ */createElement("div", {
  className: styles$3.lineStyle3
}))); };

var styles$4 = {"wrapper":"SuccessMessageView-module_wrapper__t7B2U"};

var SuccessMessageView = function () {
  var ref = useUiConfig();
  var uiConfig = ref.uiConfig;
  return /* @__PURE__ */React.createElement("div", {
    className: styles$4.wrapper
  }, /* @__PURE__ */React.createElement(CheckIcon, null), uiConfig.successMessage);
};

var styles$5 = {"wrapper":"PhoneIcon-module_wrapper__1vQw_","isAnimating":"PhoneIcon-module_isAnimating__3SywC","outer":"PhoneIcon-module_outer__qlWMW","inner":"PhoneIcon-module_inner__VbG-9","icon":"PhoneIcon-module_icon__2Ji96"};

var PhoneIcon = function () { return createElement("i", {
  className: clsx2(styles$5.wrapper, styles$5.isAnimating)
}); };

var styles$6 = {"wrapper":"ErrorMessageView-module_wrapper__8IlGm"};

var ErrorMessageView = function () {
  var ref = useUiConfig();
  var uiConfig = ref.uiConfig;
  return /* @__PURE__ */React.createElement("div", {
    className: styles$6.wrapper
  }, /* @__PURE__ */React.createElement(PhoneIcon, null), /* @__PURE__ */React.createElement("div", null, uiConfig.errorMessage));
};

var SchemaContext = createContext({});

function useSchema() {
  var context = useContext(SchemaContext);

  if (!context) {
    throw new Error("useSchema must be used within a ProjectProvider");
  }

  return context;
}

function SchemaProvider(ref) {
  var schema = ref.schema;
  var schemaId = ref.schemaId;
  var children = ref.children;

  var ref$1 = useState(schema);
  var currentSchema = ref$1[0];
  return /* @__PURE__ */createElement(SchemaContext.Provider, {
    value: {
      schema: currentSchema,
      schemaId: schemaId
    }
  }, children);
}

var styles$7 = {"error-message-color":"ErrorMessage-module_error-message-color__1WhWP"};

var ErrorMessage = function (ref) {
  var message = ref.message;

  return createElement("small", {
  className: styles$7["error-message-color"]
}, message);
};

var SelectComponent = function (ref) {
  var error = ref.error;
  var onChange = ref.onChange;
  var options = ref.options;

  var handleOnChange = function (option) {
    onChange(option.value);
  };

  var ref$1 = useUiConfig();
  var locale = ref$1.locale;
  var placeholder = locale === ZhHantLocale ? "選擇一個選項" : "Select an options";
  return /* @__PURE__ */createElement(Fragment, null, /* @__PURE__ */createElement(Dropdown, {
    options: options,
    onChange: handleOnChange,
    placeholder: placeholder
  }), error && /* @__PURE__ */createElement(ErrorMessage, {
    message: error.message
  }));
};

var styles$8 = {"wrapper":"Label-module_wrapper__26FyI"};

var Label = function (ref) {
  var name = ref.name;
  var label = ref.label;

  return createElement("label", {
  className: styles$8.wrapper,
  htmlFor: name
}, label);
};

var Input = function (ref) {
  var obj;

  var type = ref.type;
  var name = ref.name;
  var placeholder = ref.placeholder;
  var error = ref.error;
  var register = ref.register;
  return createElement(Fragment, null, /* @__PURE__ */createElement("input", Object.assign({}, {id: name,
  className: clsx2(shareStyles.fieldStyle, ( obj = {}, obj[shareStyles.fieldErrorStyle] = error, obj )),
  type: type,
  placeholder: placeholder},
  register(name))), error && /* @__PURE__ */createElement(ErrorMessage, {
  message: error.message
}));
};

var Textarea = function (ref) {
  var obj;

  var name = ref.name;
  var placeholder = ref.placeholder;
  var error = ref.error;
  var register = ref.register;
  return createElement(Fragment, null, /* @__PURE__ */createElement("textarea", Object.assign({}, {id: name,
  className: clsx2(shareStyles.textAreaStyle, ( obj = {}, obj[shareStyles.fieldErrorStyle] = error, obj )),
  placeholder: placeholder,
  rows: 5},
  register(name))), error && /* @__PURE__ */createElement(ErrorMessage, {
  message: error.message
}));
};

var domain = "https://moin.bz";

var styles$9 = {"footer":"FormFooter-module_footer__2kIzv","footerInner":"FormFooter-module_footerInner__1Iaoe","link":"FormFooter-module_link__2mDj3","logo":"FormFooter-module_logo__1jKsF","button":"FormFooter-module_button__1-C81"};

var genRefLink = function (pid) { return (domain + "?ref=" + pid); };

var FormFooter = function (ref) {
  var isSubmitting = ref.isSubmitting;
  var pid = ref.pid;

  var theme = useTheme();
  var ref$1 = useUiConfig();
  var uiConfig = ref$1.uiConfig;
  return /* @__PURE__ */createElement("footer", {
    className: styles$9.footer
  }, /* @__PURE__ */createElement("div", {
    className: styles$9.footerInner
  }, /* @__PURE__ */createElement("a", {
    className: styles$9.link,
    href: genRefLink(pid),
    target: "_blank",
    rel: "noreferrer"
  }, "Powered by", " ", /* @__PURE__ */createElement("img", {
    className: styles$9.logo,
    src: "https://cdn.moin.bz/powered.png",
    alt: "logo"
  })), /* @__PURE__ */createElement(Button, {
    type: "submit",
    style: {
      opacity: isSubmitting ? 0.8 : 1,
      backgroundColor: theme.themeColor,
      borderColor: theme.themeColor
    },
    className: styles$9.button
  }, isSubmitting ? /* @__PURE__ */createElement(Fragment, null, uiConfig.submitButtonText, "...") : /* @__PURE__ */createElement(Fragment, null, uiConfig.submitButtonText))));
};

var ViewContext = createContext("");

function useView() {
  var context = useContext(ViewContext);

  if (!context) {
    throw new Error("useView must be used within a ViewProvider");
  }

  return context;
}

function ViewProvider(ref) {
  var view = ref.view;
  var children = ref.children;

  return /* @__PURE__ */createElement(ViewContext.Provider, {
    value: view
  }, children);
}

var styles$a = {"form":"Form-module_form__3lN_t","wrapper":"Form-module_wrapper__2ErEP","fieldWrapper":"Form-module_fieldWrapper__1xp9X"};

var Form = function (ref) {
  var pid = ref.pid;
  var endpoint = ref.endpoint;
  var onListenFormSubmit = ref.onListenFormSubmit;
  var isPreview = ref.isPreview;
  var actionHook = ref.actionHook;

  var ref$1 = useUiConfig();
  var locale = ref$1.locale;
  var view = useView();
  var ref$2 = useSchema();
  var schema = ref$2.schema;
  var schemaId = ref$2.schemaId;
  var validatorSchema = genYupValidatorBySchema({
    schema: schema,
    locale: locale
  });
  var ref$3 = useForm({
    resolver: yupResolver(validatorSchema)
  });
  var control = ref$3.control;
  var register = ref$3.register;
  var handleSubmit = ref$3.handleSubmit;
  var errors = ref$3.formState.errors;
  var ref$4 = useState(false);
  var isSubmitting = ref$4[0];
  var setIsSubmitting = ref$4[1];

  var onSubmit = function (data) {
    if (!isPreview) {
      setIsSubmitting(true);

      if (onListenFormSubmit) {
        onListenFormSubmit(data);
      }

      fetch((endpoint + "/api/app/" + pid + "/message"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          config: schemaId,
          content: data
        })
      }).then(function () { return actionHook(FORM_LABEL, SENT_EVENT); }).catch(function () { return actionHook(FORM_LABEL, FAILED_TO_SUBMIT_EVENT); }).finally(function () { return setIsSubmitting(false); });
    }
  };

  if (view === FAILURE_MODAL_VIEW) {
    return /* @__PURE__ */createElement(ErrorMessageView, null);
  }

  if (view === SUCCESS_MODAL_VIEW) {
    return /* @__PURE__ */createElement(SuccessMessageView, null);
  }

  return /* @__PURE__ */createElement("form", {
    className: clsx2(shareStyles.root, styles$a.form),
    name: "moin-form",
    method: "POST",
    "data-netlify": "true",
    "netlify-honeypot": "bot-field",
    onSubmit: handleSubmit(onSubmit)
  }, /* @__PURE__ */createElement("div", {
    className: clsx2(shareStyles.root, styles$a.wrapper)
  }, schema.map(function (item) {
    var id = item.id;
    var component = item.component;
    var labelText = item.labelText;
    var placeholder = item.placeholder;
    var field;

    if (component === "input") {
      field = /* @__PURE__ */createElement(Input, {
        type: "text",
        name: id,
        placeholder: placeholder,
        register: register,
        error: errors[id]
      });
    } else if (component === "textarea") {
      field = /* @__PURE__ */createElement(Textarea, {
        name: id,
        placeholder: placeholder,
        register: register,
        error: errors[id]
      });
    } else if (component === "select") {
      field = /* @__PURE__ */createElement(Controller, {
        control: control,
        name: id,
        render: function (ref) {
          var onChange = ref.field.onChange;

          return createElement(SelectComponent, {
          onChange: onChange,
          options: item.options,
          error: errors[id]
        });
      }
      });
    }

    return /* @__PURE__ */createElement("div", {
      className: styles$a.fieldWrapper
    }, /* @__PURE__ */createElement(Label, {
      name: id,
      label: labelText
    }), field);
  })), /* @__PURE__ */createElement(FormFooter, {
    pid: pid,
    isSubmitting: isSubmitting
  }));
};

var styles$b = {"wrapper":"Modal-module_wrapper__3kpi-","mobileStyle":"Modal-module_mobileStyle__1g_ss","inlineStyle":"Modal-module_inlineStyle__1bSlG","isShownModal":"Modal-module_isShownModal__1Uv1z","modalStyle":"Modal-module_modalStyle__2IxXf","inlineWrapper":"Modal-module_inlineWrapper__2Kmvh","content":"Modal-module_content__1gC3M"};

var Modal = function (ref) {
  var handleHideForm = ref.handleHideForm;
  var isShownModal = ref.isShownModal;
  var endpoint = ref.endpoint;
  var pid = ref.pid;
  var isMobile = ref.isMobile;
  var onListenFormSubmit = ref.onListenFormSubmit;
  var isPreview = ref.isPreview;
  var isInline = ref.isInline;
  var actionHook = ref.actionHook;

  return createElement("div", {
  style: {
    visibility: isShownModal ? "visible" : "hidden"
  },
  className: clsx2(shareStyles.root, styles$b.wrapper, isMobile ? styles$b.mobileStyle : null, isShownModal ? styles$b.isShownModal : null, isInline ? styles$b.inlineStyle : styles$b.modalStyle)
}, /* @__PURE__ */createElement("div", {
  className: styles$b.inlineWrapper
}, /* @__PURE__ */createElement("div", {
  className: clsx2(shareStyles.root, styles$b.content)
}, /* @__PURE__ */createElement(ModalHeader, {
  handleHideForm: handleHideForm
}), /* @__PURE__ */createElement(Form, {
  endpoint: endpoint,
  pid: pid,
  onListenFormSubmit: onListenFormSubmit,
  isPreview: isPreview,
  actionHook: actionHook
}))));
};

var encode = function (data) { return Object.keys(data).map(function (key) { return ((encodeURIComponent(key)) + "=" + (encodeURIComponent(data[key]))); }).join("&"); };

var CiaoCiaoForm = function (ref) {
  var actionHook = ref.actionHook;
  var shouldHideMessageButton = ref.shouldHideMessageButton;
  var endpoint = ref.endpoint;
  var pid = ref.pid;
  var pluginConfig = ref.pluginConfig;
  var schemaId = ref.schemaId;
  var isMobile = ref.isMobile;
  var locale = ref.locale;
  var view = ref.view; if ( view === void 0 ) view = MESSAGE_BUTTON_VIEW;
  var isInline = ref.isInline; if ( isInline === void 0 ) isInline = false;
  var isShownModal = ref.isShownModal; if ( isShownModal === void 0 ) isShownModal = false;
  var isPreview = ref.isPreview; if ( isPreview === void 0 ) isPreview = false;

  var onMessageButtonClick = function () {
    actionHook(MESSAGE_BUTTON_LABEL, CLICK_EVENT);
  };

  var onHideForm = function () {
    if (!isInline) {
      actionHook(FORM_LABEL, HIDE_EVENT);
    }
  };

  var onListenFormSubmit = function (data) {
    actionHook(FORM_LABEL, SUBMIT_EVENT, {
      data: data,
      dataEncodedFormat: encode(data)
    });
  };

  return /* @__PURE__ */createElement(ThemeProvider, {
    theme: {
      themeColor: pluginConfig.uiConfig.color
    }
  }, /* @__PURE__ */createElement(ViewProvider, {
    view: view
  }, /* @__PURE__ */createElement(UiConfigProvider, {
    uiConfig: pluginConfig.uiConfig,
    locale: locale
  }, /* @__PURE__ */createElement(SchemaProvider, {
    schema: pluginConfig.config,
    schemaId: schemaId
  }, isShownModal || shouldHideMessageButton ? null : /* @__PURE__ */createElement(MessageButton, {
    isPreview: isPreview,
    isInline: isInline,
    isMobile: isMobile,
    handleClick: onMessageButtonClick
  }), /* @__PURE__ */createElement(Modal, {
    endpoint: endpoint,
    pid: pid,
    handleHideForm: onHideForm,
    isMobile: isMobile,
    isShownModal: isShownModal,
    onListenFormSubmit: onListenFormSubmit,
    isPreview: isPreview,
    isInline: isInline,
    actionHook: actionHook
  })))));
};

export { CiaoCiaoForm, iconMapping };
